import { render, staticRenderFns } from "./GroupReserveTable.vue?vue&type=template&id=4cc345c8&scoped=true&"
import script from "./GroupReserveTable.vue?vue&type=script&lang=js&"
export * from "./GroupReserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc345c8",
  null
  
)

export default component.exports